import React from "react";
import map from "lodash/map";
import range from "lodash/range";
import { PARAMETER_OPTIONS } from "../../constants";
import UnitInput from "./unit-input-state";
import convertToRiR from "../../utils/converters/convert-intensity";

const { RPE, RPEAMRAP, TIME, DISTANCE, LOAD, REST, VELOCITY, FREEFORM, REPS } =
  PARAMETER_OPTIONS;
class ParameterInput extends React.Component {
  constructor(props, ctx) {
    super(props, ctx);
  }

  render() {
    const {
      parameter,
      value,
      onChange,
      units,
      tabIndex,
      id,
      intensityMeasure,
      isRiR,
      preferredLoadInput,
      loadDrop,
    } = this.props;

    if (parameter === FREEFORM) {
      return (
        <textarea
          className="text-input-center text-input"
          name="freeform"
          onChange={onChange}
          value={value}
          tabIndex={tabIndex}
          id={id}
          maxLength="45"
        />
      );
    } else if ([TIME, REST, DISTANCE, VELOCITY, REPS].includes(parameter)) {
      return (
        <input
          className="text-input"
          type="text"
          name={parameter.toLowerCase()}
          onChange={onChange}
          value={value}
          maxLength="6"
          tabIndex={tabIndex}
          id={id}
        />
      );
    } else if (parameter === LOAD && preferredLoadInput === "drop") {
      return (
        <div className="relative">
          <input
            tabIndex={tabIndex}
            type="text"
            name="loadDrop"
            value={loadDrop}
            placeholder="%"
            onChange={onChange}
          />
          <span className="load-suffix">%</span>
        </div>
      );
    } else if (parameter === LOAD) {
      return (
        <UnitInput
          name={parameter.toLowerCase()}
          onChange={onChange}
          value={value}
          units={units}
          tabIndex={tabIndex}
          defaultValue={value}
          id={id}
        />
      );
    } else if ([RPE, RPEAMRAP].includes(parameter)) {
      return (
        <select
          id={id}
          className="select-input"
          name="rpe"
          value={convertToRiR(value, !isRiR)}
          onChange={(evt) => {
            if (!isRiR) {
              return onChange(evt);
            }

            const {
              target: { name, value },
            } = evt;

            return onChange({
              target: {
                name,
                value: convertToRiR(value),
              },
            });
          }}
          tabIndex={tabIndex}
        >
          <option value="">{intensityMeasure}</option>
          {isRiR
            ? map(range(-1, 4.5, 0.5), (i) => (
                <option key={i} value={i + 1}>
                  {i + 1}
                </option>
              ))
            : map(range(4, 9.5, 0.5), (i) => (
                <option key={i} value={i + 1}>
                  {i + 1}
                </option>
              ))}
          <option value="AMRAP">AMRAP</option>
        </select>
      );
    }

    return (
      <input
        className="text-input"
        type="number"
        min={1}
        step="1"
        name={parameter.toLowerCase()}
        onChange={onChange}
        value={value}
        tabIndex={tabIndex}
        id={id}
      />
    );
  }
}

export default ParameterInput;
